<template>
  <p :id="content.key" class="center">
    <img :src="content.img" alt="">
  </p>
</template>
<script>
/*
封面
*/
export default {
  name: "frontCover",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  }
}
</script>

<style lang="scss" scoped>
p{
  img{
    max-width: 100%;
    display: block;
  }
}
</style>